export const QUESTION_ANSWERED = 'TASTE_PROFILE_ONBOARDING/QUESTION_ANSWERED'

export function answerQuestion (questionId, chosenAnswer) {
  return {
    type: QUESTION_ANSWERED,
    data: { questionId, chosenAnswer }
  }
}
